import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import {
  DeletedEmailCampaignIssue,
  EmailCampaignIssueStatistics,
  EmailHistoryStatus,
  EmailIssue,
  EmailIssueArray,
  EmailPreview,
  ExportEmailCsv
} from '@models/email/email-issue';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EmailHistoryService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getSmsSentList(
    filterStatus?: EmailHistoryStatus[],
    excludeStatus?: EmailHistoryStatus[],
    dateFrom?,
    dateTo?,
    idCampaign?,
    subject?,
    pageNum?,
    pageSize?,
    sortColumn?,
    sortDirection?
  ): Observable<EmailIssueArray> {
    let params = new HttpParams();

    const body = {
      filterStatus,
      excludeStatus,
      dateFrom,
      dateTo,
      idCampaign,
      subject
    };

    params = params.append('page', pageNum ? pageNum : '1');
    params = params.append('size', pageSize ? pageSize : '10');

    if (sortColumn) {
      switch (sortColumn) {
        case 'lastSaveTime':
          params = params.append('sortColumn', 'LAST_SAVE_TIME');

          break;
        case 'sendDate':
          params = params.append('sortColumn', 'SEND_DATE');

          break;
        case 'sendStatus':
          params = params.append('sortColumn', 'SEND_STATUS');

          break;
        default:
          params = params.append('sortColumn', 'NAME');
          break;
      }
    }
    params = params.append('sortDirection', sortDirection ? sortDirection : 'd');

    return this.http.post(this.baseUrl + 'email/history/list-issues', body, { params }).pipe(
      map(data => {
        return EmailIssueArray.deserialize({
          data: (data && (data as any).data ? ((data as any).data as Array<string>) : []).map(data2 => EmailIssue.deserialize(data2)),
          total: (data as any).total
        });
      })
    );
  }

  getEmailCampaignIssue(idCampaign): Observable<EmailIssue> {
    return this.http.get<EmailIssue>(this.baseUrl + 'email/history/' + idCampaign + '/campaign-issue');
  }

  copyEmailCampaignIssue(idCampaignIssue): Observable<any> {
    return this.http.post(this.baseUrl + 'email/history/' + idCampaignIssue + '/copy-message', {});
  }

  getEmailPreview(idCampaignIssue): Observable<EmailPreview> {
    return this.http.get<EmailPreview>(this.baseUrl + 'email/history/' + idCampaignIssue + '/preview');
  }

  deleteEmailCampaignIssue(idCampaignIssue): Observable<DeletedEmailCampaignIssue> {
    return this.http.delete<DeletedEmailCampaignIssue>(this.baseUrl + 'email/history/' + idCampaignIssue);
  }

  getEmailCampaignIssueStatistics(idCampaignIssue): Observable<EmailCampaignIssueStatistics> {
    return this.http.get<EmailCampaignIssueStatistics>(this.baseUrl + 'email/history/' + idCampaignIssue + '/stats-message');
  }

  exportCsv(idCampaignIssue): Observable<ExportEmailCsv> {
    return this.http.get<ExportEmailCsv>(this.baseUrl + 'email/history/' + idCampaignIssue + '/export-history');
  }
}
